import { useTranslation } from "react-i18next";
import { Select } from "@/shared/ui";
import type { BankAccount } from "../../../types";

interface AccountSelectorProps {
  accounts: BankAccount[];
  selectedIban: string | null;
  onSelect: (iban: string | null) => void;
}

export default function AccountSelector({ accounts, selectedIban, onSelect }: AccountSelectorProps) {
  const { t } = useTranslation("BankingPage");

  if (accounts.length <= 1) return null;

  const options = accounts.map((acc) => ({
    label: `${acc.iban} (${acc.balance.currency})`,
    value: acc.iban,
  }));

  return (
    <Select<string>
      label={t("account.select")}
      options={options}
      value={selectedIban}
      onChange={onSelect}
      width="w-64"
    />
  );
}
